import { FC } from 'react';
import { getNumWord } from '@/helpers/helpers';
import styles from './BookCardRating.module.scss';

interface IBookCardRating {
  rating: number | undefined;
  voted?: number | undefined;
}

const BookCardRating: FC<IBookCardRating> = ({ rating, voted }) => {
  const bookRating = Number(rating);

  const getCounterWords = () => {
    return getNumWord(voted, ['оценка', 'оценки', 'оценок']);
  };

  if (bookRating > 0 && bookRating < 6) {
    const greyStars = 5 - bookRating;
    return (
      <>
        {Array.from(Array(bookRating), () => {
          return <span className={`${styles.bookCardStar} ${styles.bookCardStar_active}`} key={`${Math.random()}-orange`}></span>;
        })}
        {Array.from(Array(greyStars), () => {
          return <span className={`${styles.bookCardStar}`} key={`${Math.random()}-gray`}></span>;
        })}
        <span className={styles.bookCardStar__txt}>
          {bookRating}{' '}
          <span className={styles.bookCardStar__txtVoted}>
            {voted} {getCounterWords()}
          </span>
        </span>
      </>
    );
  } else {
    return (
      <>
        {Array.from(Array(5), () => {
          return <span className={styles.bookCardStar} key={`${Math.random()}-gray`}></span>;
        })}
        <span className={styles.bookCardStar__txt}>{bookRating}</span>
      </>
    );
  }
};

export default BookCardRating;
